import { useEffect, useRef, useState } from "react";
import { paymentSystems } from "../../data/static-data";
import { useLazyGetLinkToPaySessionQuery } from "../../api/getShipmetBillPaymentLink/getShipmentBillLinkToPaySession";
import BillInfo from "./BillInfo";
import SelectPaymentSystem from "./SelectPaymentSystem";
import { useDispatch } from "react-redux";
import { setUnauthorized } from "./shipmentBillsSlice";
import GreenSpinner from "../../components/loaders/GreenSpinner";
import { pushAlert } from "../alerts/alertSlice";
import { useTranslation } from "react-i18next";
import Nestpay from "./Nestpay";

import BillInfoDetails from "./BillInfoDetails";

const Bill = ({ bill, selectedTrc }) => {
    const { t } = useTranslation();
    const [getPaymentLink, { data: paymentLinkData, error: paymentLinkError }] =
        useLazyGetLinkToPaySessionQuery();
    const [pageNumber, setPageNumber] = useState(1);
    const dispatch = useDispatch();
    const thisRef = useRef(null);
	const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        if (selectedTrc && bill.trc === selectedTrc) {
            setIsSelected(true);
			if (thisRef?.current) {
                thisRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
                thisRef.current.style.backgroundColor =
                    "rgb(187 247 208)"; //bg-green-400
            }
        }
    }, [selectedTrc, bill.trc]);

    const setPageToSelectPaymentSystem = () => {
        setPageNumber(2);
    };

    const setPageToInfo = () => {
        setPageNumber(1);
    };

    const setPageToLoading = () => {
        setPageNumber(4);
    };

    const handlePayButtonClick = () => {
        setPageToSelectPaymentSystem();
    };

    const setPageToNestpay = () => {
        setPageNumber(5);
    };

    const handleSelectCurrencyForMoka = (currency) => {
        setPageToLoading();
        getPaymentLink({
            shipmentBillID: bill.id,
            paymentSystem: paymentSystems.moka.value,
            currency: currency,
        });
    };

    const handleTinkoffClick = (currency) => {
        setPageToLoading();
        getPaymentLink({
            shipmentBillID: bill.id,
            paymentSystem: paymentSystems.tinkoff.value,
            setPageToInfo,
        });
    };

    const handleNestpayClick = () => {
        setPageToNestpay();
    };

    //Payment link handling
    useEffect(() => {
        if (paymentLinkData && paymentLinkData.ok && paymentLinkData.url) {
            setPageNumber(1);
            window.location.href = paymentLinkData.url;
        }
    }, [paymentLinkData]);

    useEffect(() => {
        if (paymentLinkError && paymentLinkError.unauthorized) {
            dispatch(setUnauthorized(true));
            return;
        }
        if (paymentLinkError) {
            setPageNumber(1);
            dispatch(
                pushAlert({
                    message: t("bill.errors.uable_to_get_payment_link"),
                    type: "danger",
                    delay: 2000,
                })
            );
        }
    }, [dispatch, paymentLinkError, t]);

    return (
        <div
            ref={thisRef}
            className="overflow-hidden w-full max-w-sm border-2 xs:border-3 rounded-lg border-emerald-600 pt-3 text-3xs xs:text-xs sm:text-md"
        >
            {pageNumber === 1 && (
                <>
                    <div className="px-5 pb-3">
                        <BillInfo
                            bill={bill}
                            handlePayButtonClick={handlePayButtonClick}
                        />
                    </div>
                    <div className="">
                        <BillInfoDetails bill={bill} isSelected={isSelected} />
                    </div>
                </>
            )}
            {/* Payment systems */}
            {pageNumber === 2 && (
                <SelectPaymentSystem
                    goBack={setPageToInfo}
                    handleMokaPayClick={() =>
                        handleSelectCurrencyForMoka("TRY")
                    }
                    handleTinkoffPayClick={handleTinkoffClick}
                    handleNestpayClick={handleNestpayClick}
                />
            )}

            {/* Loading page */}
            {pageNumber === 4 && <GreenSpinner width={40} />}

            {/* Nestpay */}
            {pageNumber === 5 && (
                <Nestpay
                    billID={bill?.id}
                    setPageToSelectPaymentSystem={setPageToSelectPaymentSystem}
                />
            )}
        </div>
    );
};

export default Bill;
